import { render } from "./AppSidebar.vue?vue&type=template&id=d7a46b66&scoped=true"
import script from "./AppSidebar.js?vue&type=script&lang=js&external"
export * from "./AppSidebar.js?vue&type=script&lang=js&external"

import "./AppSidebar.scss?vue&type=style&index=0&id=d7a46b66&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7a46b66"]])

export default __exports__